//监控告警记录常量定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 异常类型
 */
class Type extends UltMeta {
    DEVICE = new Meta(1, "设备异常");
    SHIP = new Meta(2, "船舶异常");
}

export const TYPE = new Type();

/**
 * 处理状态
 */
class HandleState extends UltMeta {
    UNHANDLED = new Meta(1, "未处理");
    HANDLED = new Meta(2, "已处理");
}

export const HANDLE_STATE = new HandleState();
